<template>

  <div style="height: 100%; position: relative;">

    <div id="loadingBar_index" v-show="isShowingProgress"
         style="top: 50%;
          position: absolute;
          width: 400px;
          left: calc(50% - 200px);"  >
        <el-progress :text-inside="true" :stroke-width="26"  :percentage="percentNum"></el-progress>
    </div>

    <div   v-show="isShowingBall" style="height:100%;" id='cesiumContainer_index'></div>

    <infoHover ref="info"></infoHover>
  </div>
 
</template>
<script>
import proj4 from 'proj4';
import parseAPNG from 'apng-js';

import { getEquipmentList ,getShowType} from "@/utils/indexApi";
import infoHover from '@/components/index/infoHover.vue';
var viewer = null;
var clickEntity = null
export default{
  components:{infoHover},
  props:{
    equipmentPropData: {
      default: {}
    }
  },
  data(){
    return {
       glb_prefix: "https://ztjg-zhgd-dev.oss-cn-shanghai.aliyuncs.com/glb",
       overlayChartObj:{},
       allowedRectangle:null,
       isBim : false,
       percentNum:0,
       isShowingProgress: false,
       isShowingBall: false,
      centerPositionStr:'',
      currentAnimation: '',
      currentHeading:0 ,
      projectPitch : Cesium.Math.toRadians(-45),
      project2Distance : 400.0 , //米
      heightOffset:100 ,
      rotationSpeed: Cesium.Math.toRadians(1),
      defaultImgMap : {
        '实名制':require('@/assets/image/index/实名制扎点备份2@2x.png'),
        '视频监控':require('@/assets/image/index/视频扎点备份11@2x.png'),
        '环境监测':require('@/assets/image/index/扬尘监测扎点@2x.png')
      },
      animationImgMap : {
        '实名制':require('@/assets/image/index/animation/实名制扎点animation.png'),
        '视频监控':require('@/assets/image/index/animation/视频监控扎点animation.png'),
        '环境监测':require('@/assets/image/index/animation/扬尘监测扎点animation.png')
      }
    }
  },
  watch:{
    equipmentPropData(){

    }
  },
  methods:{
    cancelAround(){
      console.log('cancelaround............')
      cancelAnimationFrame( this.currentAnimation);
    },
    rotateAroundCenter() {
      if(this.centerPositionStr){
       var centerPositionArray  =  this.centerPositionStr.split(",")

        var  projectCenterPoint = Cesium.Cartesian3.fromDegrees(centerPositionArray[0],centerPositionArray[1], 50);
        this.currentHeading += this.rotationSpeed / 60; // 每帧旋转的角度
        if (this.currentHeading >= Cesium.Math.TWO_PI) {
          this.currentHeading -= Cesium.Math.TWO_PI;
        }
        // 计算相机的新位置
        var cameraPosition = new Cesium.Cartesian3(
            projectCenterPoint.x + this.project2Distance * Math.cos(this.currentHeading),
            projectCenterPoint.y + this.project2Distance * Math.sin(this.currentHeading),
            projectCenterPoint.z + this.heightOffset
        );
        // 使用 lookAt 方法设置相机
        viewer.camera.lookAt(
            projectCenterPoint, // 中心点
            Cesium.Cartesian3.subtract(cameraPosition, projectCenterPoint, new Cesium.Cartesian3()), // 观察方向
            new Cesium.HeadingPitchRange(this.currentHeading, this.projectPitch, this.project2Distance) // 方向和距离
        );
        this.currentAnimation = requestAnimationFrame(this.rotateAroundCenter );

      }

    },
    setProgress(){

      var pNumber = 0;
      const interval = setInterval(() => {
        if(pNumber === 0){
         this.isShowingProgress = true;
        }
        pNumber += 2;

        if (pNumber >= 100) {
          this.isShowingProgress = false;
          this.isShowingBall = true;
          clearInterval(interval);
        }
        this.percentNum = pNumber;
      }, 25);

    },
    initMap(){
      const _this= this
      var token = 'f0d0a66ca35dfc421a76b2fccc633db7';
      // 服务域名
      var tdtUrl = 'https://t{s}.tianditu.gov.cn/';
      // 服务负载子域
      var subdomains=['0','1','2','3','4','5','6','7'];

      // 设置 Cesium Ion 访问令牌
      Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJjMjc2MDM1Zi1lOGQ0LTRlNTAtODMwYi04NzIxNjdkMTQ1ZTAiLCJpZCI6MjM2MDQxLCJpYXQiOjE3MjQyMjAyNDl9.YAXzj8kNfuxIxHZFZW2bH1pJPJk9hmcvnEslsTk7SuQ';

      viewer = new Cesium.Viewer("cesiumContainer_index", {
        infoBox: false,
        selectionIndicator: false,
        shadows: true,
        shouldAnimate: true,
        animation:false,
        timeline:false,
        fullscreenButton:false,
        geocoder:false,
        homeButton:false,
        navigationHelpButton:false,
        sceneModePicker:false,
        baseLayerPicker:false,
        creditContainer:document.createElement("div"),

      });

      //去掉影子，太阳光
      viewer.scene.shadowMap.enabled = false;
      viewer.scene.globe.enableLighting = true;
      viewer.scene.fog.enabled = false;

      // 抗锯齿
      viewer.scene.fxaa = true;
      viewer.scene.postProcessStages.fxaa.enabled=false;
      // 水雾特效
      viewer.scene.globe.showGroundAtmosphere = true;
      //地形检测
      viewer.scene.globe.depthTestAgainstTerrain = true



      // 叠加影像服务
      var imgMap = new Cesium.UrlTemplateImageryProvider({
        url: tdtUrl + 'DataServer?T=img_w&x={x}&y={y}&l={z}&tk=' + token,
        subdomains: subdomains,
        tilingScheme : new Cesium.WebMercatorTilingScheme(),
        maximumLevel : 18
      });
      viewer.imageryLayers.addImageryProvider(imgMap);

      // 叠加国界服务
      var iboMap = new Cesium.UrlTemplateImageryProvider({
        url: tdtUrl + 'DataServer?T=ibo_w&x={x}&y={y}&l={z}&tk=' + token,
        subdomains: subdomains,
        tilingScheme : new Cesium.WebMercatorTilingScheme(),
        maximumLevel : 10
      });
      viewer.imageryLayers.addImageryProvider(iboMap);

      // 叠加三维地名服务
      var labelLayer = new Cesium.WebMapTileServiceImageryProvider({
        url: tdtUrl+'cia_w/wmts?tk='+token,
        layer: 'cia',
        style: 'default',
        format: 'tiles',
        tileMatrixSetID: 'w',
        maximumLevel: 18,
        subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
        proxy: new Cesium.DefaultProxy('/proxy/')
      });
      viewer.imageryLayers.addImageryProvider(labelLayer);


//###################################
      //添加光照效果，这里可以再添加点光效果，需要研究
      viewer.scene.light = new Cesium.DirectionalLight({
        direction: viewer.scene.camera.directionWC,
      });

      viewer.scene.preRender.addEventListener(function (scene, time) {
        viewer.scene.light.direction = Cesium.Cartesian3.clone(
            viewer.scene.camera.directionWC,
            viewer.scene.light.direction
        );
      });

      //设置光照角度跟随摄像机视角，并实时刷新光照角度
      // 亮度设置
      let stages = viewer.scene.postProcessStages;
      viewer.scene.brightness = viewer.scene.brightness || stages.add(Cesium.PostProcessStageLibrary.createBrightnessStage());
      viewer.scene.brightness.enabled = true;
      viewer.scene.brightness.uniforms.brightness = Number(1.05);

//###################################

      // 禁用默认的双击事件处理器
      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
      
      const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);

      let longitudeString  ;
      let latitudeString;

      let isDragging = false;
      let dragStartCamera;
      // 左键点击效果
      handler.setInputAction(function (movement) {
        // viewer.selectedEntity = undefined;

        const pickedObject = viewer.scene.pick(movement.position);
        _this.$emit('clickEntity', '','')

        //父页面的弹窗消失
        _this.$refs.info.closePop();

        if ( Cesium.defined(pickedObject) ) {
          // console.log('clicked something.....................')
          const pickedObjectEntity = pickedObject.id

          // 判断是否点击了Entity
          if (Cesium.defined(pickedObject.primitive) && pickedObject.primitive instanceof  Cesium.Billboard) {
            console.log('Clicked on Billboard');
            // pickedObjectEntity.billboard.scale = 1.4;

            if(clickEntity){
               clickEntity.billboard.image = _this.defaultImgMap[clickEntity.$type];
               clickEntity.billboard.scale = 0.5;
            }
            clickEntity = pickedObjectEntity;

            let type = pickedObjectEntity.$type;
            // 创建 canvas 和 context
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            _this.loadAPNG(ctx,_this.animationImgMap[type]).then(player => {
              _this.updateBillboardImage(player, pickedObjectEntity.billboard,_this.defaultImgMap[type]);
            }).catch(error => {
              console.error("Error loading APNG:", error);
            });

            const fnMap ={
              "实名制": ()=>_this.$emit('clickEntity', pickedObjectEntity.$id,'实名制通道'),
              "视频监控":()=>_this.$refs.info.openPop(_this.getPos(viewer,movement), pickedObjectEntity.$id),
              "环境监测":()=>_this.$emit('clickEntity', pickedObjectEntity.$id,'环境监测')
            }

            fnMap[type]&&fnMap[type]()
            var info = _this.getSingleEquipment( pickedObjectEntity.$id)

            if(info.cameraPosition){
              _this.cancelAround()
               var cameraPosition = JSON.parse(info.cameraPosition)
              _this.flyToPosition(cameraPosition)
            }

          }
          else if (Cesium.defined(pickedObject.primitive) && pickedObject.primitive instanceof Cesium.Entity) {

            console.log('Clicked on an Entity');

          } else if (Cesium.defined(pickedObject.primitive) && pickedObject.primitive instanceof Cesium.Model ) {

            // viewer.trackedEntity(pickedObject)
            const pickedObjectEntity = pickedObject.id
            const properties = pickedObjectEntity.properties;

            console.log('Clicked BIM model feature:', properties);

            console.log('Clicked on a Model');


          } else {
            console.log('Clicked on something else');
          }
          // _this.$refs.info.openPop(_this.getPos(viewer,movement))

        }else{

          // if(clickEntity){
          //   clickEntity.billboard.image = _this.defaultImgMap[clickEntity.$type]
          // }

        }
      
        console.log(longitudeString+","+latitudeString);

      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      // 左键按下事件
      handler.setInputAction(function(click){
        _this.$refs.info.closePop();

        // if(clickEntity){
        //   clickEntity.billboard.scale = 1
        // }

        if(!_this.isBim){
          isDragging = true;
          // 保存拖动前的相机状态
          // dragStartCamera = viewer.camera.clone();
          const cameraPosition = viewer.camera.positionWC;
          dragStartCamera = Cesium.Cartographic.fromCartesian(cameraPosition);
        }

        },Cesium.ScreenSpaceEventType.LEFT_DOWN);

      // 鼠标移动事件
      handler.setInputAction(function (movement) {
        const scene = viewer.scene;
        if (scene.mode !== Cesium.SceneMode.MORPHING) {
          if (scene.pickPositionSupported) {
            const cartesian = viewer.camera.pickEllipsoid(
                movement.endPosition,
                scene.globe.ellipsoid
            );

            if (cartesian) {
              const cartographic = Cesium.Cartographic.fromCartesian(
                  cartesian
              );
              longitudeString = Cesium.Math.toDegrees(
                  cartographic.longitude
              ).toFixed(10);

              latitudeString = Cesium.Math.toDegrees(
                  cartographic.latitude
              ).toFixed(10);

              // console.log(longitudeString+","+latitudeString);

            }

          }
        }
        if (isDragging) {
       
          // 拖动过程中不需要做特殊处理
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
viewer.scene.postRender.addEventListener((e) => {
  if(clickEntity&&clickEntity.$type==='视屏监控'){
    let winPos = viewer.scene.cartesianToCanvasCoordinates(clickEntity.id.position._value);
    const click = {
      position:{
        x:winPos.x,
        y:winPos.y
      }
    }
    this.$refs.info.openPop(_this.getPos(viewer,click),clickEntity.$id)
  }
})
// 左键释放事件
      handler.setInputAction(() => {
        if (!_this.isBim && isDragging) {
          isDragging = false;

          // 获取当前相机的位置
          const cameraPosition = viewer.camera.positionWC;
          const cartographic = Cesium.Cartographic.fromCartesian(cameraPosition);
          const longitude = Cesium.Math.toDegrees(cartographic.longitude);
          const latitude = Cesium.Math.toDegrees(cartographic.latitude);

          // 检查当前相机位置是否在允许的区域内
          if (longitude <  (this.allowedRectangle.west - 0.002 ) || longitude >  (this.allowedRectangle.east + 0.002 )  ||
              latitude <  (this.allowedRectangle.north - 0.0025 ) || latitude >  (this.allowedRectangle.south + 0.0025 ) )  {
          //   if (!Cesium.Rectangle.contains(this.allowedRectangle, cartographic)) {
            // 如果不在允许的区域内，将相机重置到拖动前的位置

              const centerLongitude = Cesium.Math.toRadians((this.allowedRectangle.west + this.allowedRectangle.east) / 2);
              const centerLatitude = Cesium.Math.toRadians((this.allowedRectangle.south + this.allowedRectangle.north) / 2);

            viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromRadians(centerLongitude, centerLatitude, cartographic.height),
              duration: 1.5 // 平滑过渡时间
            });


          }
        }
      }, Cesium.ScreenSpaceEventType.LEFT_UP);


      //   使用zoomTo后，页面模型想要转动方向看不同角度的试图，需要使用鼠标中键才可以，但是可以使用左键拖动地图显示的位置
      // 而使用viewer.trackedEntity 追踪某一个模型后，则可以使用鼠标左键直接改变角度查看，但是不能拖动查看另外的地方


      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(103.84, 31.15, 7000000),
        orientation: {
          heading :  Cesium.Math.toRadians(348.4202942851978),
          pitch : Cesium.Math.toRadians(-89.74026687972041),
          roll : Cesium.Math.toRadians(0)
        },
        complete: ()=> {

          // 定位完成之后的回调函数
          setTimeout(()=>{
            //加载BIM或者底图
            _this.judgeIsBim();

          },500)

        }
      });

    },
    async  loadAPNG(ctx,url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();
      const apng = parseAPNG(arrayBuffer);
      const player = await apng.getPlayer(ctx);
      // player.loop = true; // 设置循环播放
      player.play();
      return player;
    },
     updateBillboardImage(player, billboard,defaultImg) {
       billboard.scale = 1;
      let currentFrameImage  = defaultImg;
        if (player && player.currentFrame) {
          billboard.image = new Cesium.CallbackProperty(() => {
            if (player && player.currentFrame) {
              currentFrameImage  = player.currentFrame.imageElement;
            }
            return currentFrameImage ;
          }, false);
        }
       return currentFrameImage ;
      },
    getPos(viewer,click){
      const canvasRect = viewer.scene.canvas.getBoundingClientRect();
      return {left:click.position.x+canvasRect.left+'px',top:click.position.y+canvasRect.top-100+'px'}
    },
    bindMapMove() {
        const cesiumViewer = viewer;
        const tt = this;
        cesiumViewer.scene.preRender.addEventListener(() => {
            tt.getPos(tt.overlayChartObj);
        });
      },
    loadRongNan(){


      this.addGLBModel("1",  this.glb_prefix+"/tw/1/11.glb",
          103.84478633,30.44041249 ,   -1  ,  0.9 ,
          115 , 0 , 0    );

      this.addGLBModel("2",  this.glb_prefix+"/tw/2/22.glb",
          103.84535129,30.44012701  ,   -1  ,  0.9 ,
          115 , 0 , 0    );

      this.addGLBModel("3",  this.glb_prefix+"/tw/3/33.glb",
          103.84581591,30.43994029  ,   -1  ,  0.9 ,
          115 , 0 , 0    );

      this.addGLBModel("4",  this.glb_prefix+"/tw/4/4.glb",
          103.84607514,30.43917043  ,   -1  ,  1 ,
          22 , 0 , 0    );

      this.addGLBModel("5",  this.glb_prefix+"/tw/5/5.glb",
          103.84601944,30.43901948 ,   -1  ,  1 ,
          22 , 0 , 0    );

      this.addGLBModel("6",  this.glb_prefix+"/tw/6/66.glb",
          103.84451437,30.43859492,   -1  ,  1 ,
          115 , 0 , 0    );

      this.addGLBModel("7",  this.glb_prefix+"/tw/7/7.glb",
          103.84387354,30.43884774  ,   -1  ,  1 ,
          115 , 0 , 0    );

      this.addGLBModel("8",  this.glb_prefix+"/tw/8/8.glb",
          103.84394784,30.43927024  ,   -1  ,  1 ,
          119 , 0 , 0    );

      this.addGLBModel("9",  this.glb_prefix+"/tw/9/9.glb",
          103.84493180,30.43927052 ,   -1  ,  1 ,
          205 , 0 , 0    );

      this.addGLBModel("10",  this.glb_prefix+"/tw/10/10.glb",
          103.84515324,30.43979648 ,   -1  ,  1 ,
          115 , 0 , 0    );


      this.addGLBModel("11",  this.glb_prefix+"/tw/11/11.glb",
          103.84439448,30.43974162 ,   -1  ,  1 ,
          119 , 0 , 0    );
    },
    loadChuanZang(){

      // this.addGLBModel("pujiang",   "https://ztjg-zhgd-prod.oss-cn-shanghai.aliyuncs.com/zhgd/2024.12.05/%E6%B5%A6%E6%B1%9F%E7%AB%99.glb",
      this.addGLBModel("pujiang",   "https://ztjg-zhgd-prod.oss-cn-shanghai.aliyuncs.com/bim/%E6%B5%A6%E6%B1%9F%E7%AB%99-%E6%88%BF%E9%A1%B6.glb",
          103.4947134947,30.1945963554 ,   1  ,  1 ,
          43 , 0 , 0    );

      this.addGLBModel("shouan",   "https://ztjg-zhgd-prod.oss-cn-shanghai.aliyuncs.com/zhgd/2024.12.05/%E5%AF%BF%E5%AE%89%E7%AB%99.glb",
          104.4947134947,30.1945963554 ,   1  ,  1 ,
          43 , 0 , 0    );



    },
    addAllModel(pid){
      if(pid === 6 ){//蓉南
        this.loadRongNan()
      } else if(pid === 53 ){//川藏
        this.loadChuanZang()
      }
    },

    addGLBModel(id, url, longitude, latitude, height, scale  , heading1 , pitch1  , roll1  ) {
      // viewer.entities.removeAll();
      console.log('add model .....' + id );
      const position = Cesium.Cartesian3.fromDegrees(
          longitude,
          latitude,
          height
      );

      var heading = Cesium.Math.toRadians(heading1); // 航向，通常表示为从北方顺时针的角度，这里转换为弧度
      var pitch = Cesium.Math.toRadians(pitch1);   // 俯仰，表示从水平面向上或向下的角度，这里转换为弧度
      var roll = Cesium.Math.toRadians(roll1);     // 翻滚，表示物体围绕其前进方向的旋转角度，这里转换为弧度

      var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);

      const orientation = Cesium.Transforms.headingPitchRollQuaternion(
          position,
          hpr
      );
      const entity = viewer.entities.add({
        id:"id"+id,
        name: url,
        position: position,
        orientation: orientation,
        model: {
          uri: url,
          scale: scale, // 设置模型的大小，这里设置为1倍
          minimumPixelSize: 10,
          maximumScale: 500
        },
      });
      // viewer.trackedEntity = entity;

    },
    flyToModel(id){
      viewer.flyTo(
          viewer.entities.getById(id),
          {
            maximumHeight : 100,
            offset : {
              heading : Cesium.Math.toRadians(25.0), //航向角（以弧度为单位）。
              pitch : Cesium.Math.toRadians(-10.0), //以弧度为单位的俯仰角。
              range : 105.0 //与中心的距离（以米为单位）。
            },
            duration : 2
          });
    },
    flyToPosition(position ){
        viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(
              position.longitude,
              position.latitude,
              position.height
          ),
          orientation: {
            heading: Cesium.Math.toRadians (position.heading||0 ),
            pitch:  Cesium.Math.toRadians (position.pitch||-90),
            roll: Cesium.Math.toRadians  (position.roll||0)
          },
          duration: 2,
          endTransform: Cesium.Matrix4.IDENTITY
        });


    },

    setGlobeBlackColor(){
      // 获取地球实体
      var globe = viewer.scene.globe;
    // 创建一个混合材质，保留地球纹理的同时设置底色为黑色
      var blackMaterial = new Cesium.Material({
        fabric: {
          type: 'Color',
          uniforms: {
            color: new Cesium.Color(0, 0, 0, 0.9) // 黑色
          }
        }
      });

    // 设置地球的底色为黑色，但保留纹理细节
      globe.material = blackMaterial;
    },
    clearGlobeBlackColor(){
      viewer.scene.globe.material = undefined;

    },
    limitZoomLevel(){
      viewer.scene.screenSpaceCameraController.enableZoom=true;    //允许用户放大和缩小
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 1;
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = 10000;
    },
    set2DModel(){
      viewer.scene.mode = Cesium.SceneMode.SCENE3D;//启用3D模式
      viewer.scene.screenSpaceCameraController.enableRotate=true;   //允许用户旋转世界
      viewer.scene.screenSpaceCameraController.enableTilt=false;    //允许用户倾斜相机
      viewer.scene.screenSpaceCameraController.enableLook=true;   //允许用户使用 free-look

      viewer.scene.screenSpaceCameraController.enableZoom=true;    //允许用户放大和缩小
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 80;
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = 450;

      viewer.scene.screenSpaceCameraController.enableTranslate= true ;     //允许用户在地图上平移
    },
    clear2DModel(){
      viewer.scene.mode = Cesium.SceneMode.SCENE3D;//启用3D模式
      viewer.scene.screenSpaceCameraController.enableRotate=true;   //允许用户旋转世界
      viewer.scene.screenSpaceCameraController.enableTilt=true;    //允许用户倾斜相机
      viewer.scene.screenSpaceCameraController.enableLook=true;   //允许用户使用 free-look

      viewer.scene.screenSpaceCameraController.enableZoom=true;    //允许用户放大和缩小
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = undefined;
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = undefined;

      viewer.scene.screenSpaceCameraController.enableTranslate= true ;     //允许用户在地图上平移
    },
    //宽高单位km
    loadNoBimPicture(imageUrl , position){
      if(!imageUrl){
        return;
      }
      console.log("loadNoBimPicture.........")

      this.setGlobeBlackColor()
      this.set2DModel();

      // console.log(position,"position")
      var split = position.split(",");
      var west = parseFloat(split[0] )
      var south = parseFloat(split[1])
      var east = parseFloat(split[2])
      var north = parseFloat(split[3])


      const layers = viewer.scene.imageryLayers;

      // 计算图片的实际长宽比
      const imageWidth = 8125; // 替换为你的图片实际宽度
      const imageHeight = 4574; // 替换为你的图片实际高度
      const imageAspectRatio = imageWidth / imageHeight;

      // 计算地理范围的长宽比
      const geoWidth = Cesium.Math.toRadians(east - west);
      const geoHeight = Cesium.Math.toRadians(north - south);
      const geoAspectRatio = geoWidth / geoHeight;

      // 调整地理范围以匹配图片的长宽比
      if (imageAspectRatio > geoAspectRatio) {
        // 图片较宽，调整经度范围
        const newGeoWidth = geoHeight * imageAspectRatio;
        const centerLongitude = (west + east) / 2;
        const halfNewGeoWidth = newGeoWidth / 2;
        west = centerLongitude - Cesium.Math.toDegrees(halfNewGeoWidth);
        east = centerLongitude + Cesium.Math.toDegrees(halfNewGeoWidth);

      } else {
        // 图片较高，调整纬度范围
        const newGeoHeight = geoWidth / imageAspectRatio;

        const centerLatitude = (south + north) / 2;

        const halfNewGeoHeight = newGeoHeight / 2;

        south = centerLatitude - Cesium.Math.toDegrees(halfNewGeoHeight);

        north = centerLatitude + Cesium.Math.toDegrees(halfNewGeoHeight);
      }

      // console.log("corner",west,south,east,north)

      const imageryLayer = Cesium.ImageryLayer.fromProviderAsync(
          Cesium.SingleTileImageryProvider.fromUrl(
              imageUrl,
              {
                rectangle: Cesium.Rectangle.fromDegrees(
                    west,
                    south,
                    east,
                    north
                ),
              }
          )
      );
      layers.add(imageryLayer);

      this.allowedRectangle = new Cesium.Rectangle(west, south, east, north);

      imageryLayer.alpha = 1.0;
      imageryLayer.brightness = 10;

      viewer.zoomTo(imageryLayer).then(
          function(){

            // zoomTo完成后设置相机高度
            var desiredHeight = 300; // 你想要的高度（单位：米）

            // 获取当前相机位置
            var position = viewer.camera.positionCartographic;

            // 使用Cartographic位置设置新的相机高度
            viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromRadians(
                   (position.longitude),
                   (position.latitude),
                  desiredHeight
              ),
              orientation: {
                heading: viewer.camera.heading,
                pitch: viewer.camera.pitch,
                roll: viewer.camera.roll
              },
              duration: 2.5 // 飞行到新位置的持续时间（秒）
            });

          }
      );
    },

    resetProjectPosition(){
      if(this.centerPositionStr){
        var centerPosition = this.centerPositionStr.split(",")
        viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(centerPosition[0], centerPosition[1] , 100),
          orientation: {
              heading: Cesium.Math.toRadians(90 ),
              pitch:    Cesium.Math.toRadians(-30),
              roll: Cesium.Math.toRadians(0)
          },
          flyOverLongitude : -100.0, // 指定飞行路径的中心经度
          flyOverLongitudeWeight : 0.5 // 指定飞行路径对中心经度的偏好程度
        });

      }
    },
    addProjectTitle(projectName ){
      if(this.centerPositionStr) {
        var centerPosition = this.centerPositionStr.split(",")
        const point = new Cesium.Entity({
          position: Cesium.Cartesian3.fromDegrees(centerPosition[0], centerPosition[1], 50),
          label: {
            text: projectName,
            scale: 0.5,
            backgroundColor: Cesium.Color.AQUA,
            pixelOffset: new Cesium.Cartesian2(0, 20), // 调整垂直偏移量
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND, // 确保标签贴地
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(5000.0, 50000000.0)
          }
        });
        viewer.entities.add(point);
      }
    },
    addPoint(position, imgUrl,obj){
      console.log( obj,"addPoint..............")

      const point = new Cesium.Entity({
        $id:obj.id,
        $type:obj.type,
        position: Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude, position.height),
        label:{
          text: obj.type,
          scale: 0.4,
          backgroundColor: Cesium.Color.AQUA,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0.0, 500000.0) //  表示500公里
        },
        billboard : {
          image :imgUrl,//billboard广告牌
          show: true, // default
          pixelOffset: new Cesium.Cartesian2(0, -8), // default: (0, 0)设置图片的偏移，是按屏幕坐标来偏移的
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          scale: 0.5, // default: 1.0
          color: new Cesium.Color.fromCssColorString("#ffffff"), // default: WHITE
          rotation: 0, // default: 0.0
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          // width: 68, // default: undefined
          // height: 60, // default: undefined
          scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 500000, 0.0), // 按距离缩放，距离大于 500000 米时，图标不显示
        }
      });

      viewer.entities.add(point);

    },
    setBloom(){

      const viewModel = {
        show: true,
        glowOnly: false,
        contrast: 125,
        brightness: -0.48,
        delta: 1.0,
        sigma: 3.78,
        stepSize: 3.0,
      };
      Cesium.knockout.track(viewModel);
      const bloom = viewer.scene.postProcessStages.bloom;
      bloom.enabled = Boolean(viewModel.show);
      bloom.uniforms.glowOnly = Boolean(viewModel.glowOnly);
      bloom.uniforms.contrast = Number(viewModel.contrast);
      bloom.uniforms.brightness = Number(viewModel.brightness);
      bloom.uniforms.delta = Number(viewModel.delta);
      bloom.uniforms.sigma = Number(viewModel.sigma);
      bloom.uniforms.stepSize = Number(viewModel.stepSize);
    },

    getSingleEquipment(id){
      return  this.equipmentPropData?.list.find(ele => ele.id === id)
    } ,
    drawEquipment(){

        this.equipmentPropData?.list.forEach(item=>{
          this.addPoint(
              {longitude: item.longitude , latitude: item.latitude, height: item.height || 3 },
              this.defaultImgMap[item.type],
              item);
        })

    } ,
    setZoomTo(data){
      console.log('setZoomTo......................')

      var position = viewer.camera.position;
      // 将 Cartesian3 位置转换为 Cartographic
      var cartographic = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
      // 调整高度
      if(data === 'dec'){
        cartographic.height -= 200; // 增加100米
        if(cartographic.height < 1){
          cartographic.height = 1
        }
      }else{
        cartographic.height += 200; // 增加100米
      }

      // 将调整后的 Cartographic 位置转换回 Cartesian3
      var newPosition = Cesium.Ellipsoid.WGS84.cartographicToCartesian(cartographic);

      var camera = viewer.camera

      // 假设你想要在稍后恢复相机的方向
      var headingPitchRoll = new Cesium.HeadingPitchRoll(
          camera.heading,
          camera.pitch,
          camera.roll
      );

      // 如果需要平滑移动相机到新位置
      viewer.camera.flyTo({
        destination: newPosition,
        orientation: {
          heading: headingPitchRoll.heading,
          pitch: headingPitchRoll.pitch,
          roll: headingPitchRoll.roll
        },
        duration: 1.5
      });

    },
    judgeIsBim(){//地图加载完毕，飞到china上空调用的

      getShowType().then(res=>{
        if(res){
          const type = res.data.showType;
          const projectName = res.data.projectName;
          const projectId = res.data.projectId;

          let section = sessionStorage.getItem('currentSection')

          if(section){
            var setcionJSON = JSON.parse(section)
            this.centerPositionStr = setcionJSON.position;
          }
          //加载项目名称
          this.addProjectTitle(projectName );

          // this.limitZoomLevel();

          if(type==='bim'){

            this.isBim = true;

            //跳到项目中心旋转
            // this.rotateAroundCenter();

            //地图定位到项目工区的位位置
            if(this.centerPositionStr) {
              var centerPosition = this.centerPositionStr.split(",")
              var cameraPosition = {};
              cameraPosition.longitude = centerPosition[0];
              cameraPosition.latitude = centerPosition[1];
              cameraPosition.height = 200;
              this.flyToPosition(cameraPosition)
            }

            //加载bim模型
            this.addAllModel(projectId)
            //加载打点信息广告牌
            this.drawEquipment();

          }else if(type==='noBim'){

            this.loadNoBimPicture(res.data.urls[0].url  ,res.data.urls[0].position)
            //加载打点信息广告牌
            this.drawEquipment();

          }

        }

      })

    }
  },
  mounted(){
    this.setProgress();

    this.initMap();

  },
  created(){

  }
}
</script>